import { DataTable } from '../common/DataTable';
import { orderColumns } from '../common/tables/columns';
import type { Order } from '@/types';

interface OrderTrackingTableProps {
  orders: Order[]
}

export function OrderTrackingTable({ orders }: OrderTrackingTableProps) {
  const getRowProps = (row: any) => ({
    onClick: () => console.log('Row clicked:', row.original),
    className: 'cursor-pointer',
  });

  const renderSubComponent = (row: any) => {
    const order = row.original as Order;
    return (
      <div className="p-4 bg-gray-50 dark:bg-gray-800">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">Order Details</h3>
            <dl className="grid grid-cols-2 gap-2 text-sm">
              <dt className="text-gray-500 dark:text-gray-400">Order Date</dt>
              <dd className="text-gray-900 dark:text-gray-100">{new Date(order.orderDate).toLocaleDateString()}</dd>
              <dt className="text-gray-500 dark:text-gray-400">Requested Delivery</dt>
              <dd className="text-gray-900 dark:text-gray-100">{order.requestedDeliveryDate ? new Date(order.requestedDeliveryDate).toLocaleDateString() : '-'}</dd>
              <dt className="text-gray-500 dark:text-gray-400">Confirmed Delivery</dt>
              <dd className="text-gray-900 dark:text-gray-100">{order.confirmedDeliveryDate ? new Date(order.confirmedDeliveryDate).toLocaleDateString() : '-'}</dd>
              <dt className="text-gray-500 dark:text-gray-400">Revised Delivery</dt>
              <dd className="text-gray-900 dark:text-gray-100">{order.revisedDeliveryDate ? new Date(order.revisedDeliveryDate).toLocaleDateString() : '-'}</dd>
              <dt className="text-gray-500 dark:text-gray-400">Actual Delivery</dt>
              <dd className="text-gray-900 dark:text-gray-100">{order.actualDeliveryDate ? new Date(order.actualDeliveryDate).toLocaleDateString() : '-'}</dd>
            </dl>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">Products</h3>
            <div className="space-y-2">
              {order.products.map((product) => (
                <div key={product.id} className="bg-white dark:bg-gray-700 p-3 rounded-lg">
                  <div className="flex justify-between items-start">
                    <div>
                      <div className="font-medium text-gray-900 dark:text-gray-100">{product.name}</div>
                      <div className="text-sm text-gray-500 dark:text-gray-400">{product.category}</div>
                    </div>
                    <div className="text-right">
                      <div className="font-medium text-gray-900 dark:text-gray-100">{product.quantity}x</div>
                      <div className="text-sm text-gray-500 dark:text-gray-400">{product.unitPrice.toFixed(2)}</div>
                    </div>
                  </div>
                  {product.isCustom && (
                    <div className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                      <div>Drawing: {product.drawingNumber}</div>
                      <div className="truncate" title={product.specifications}>
                        {product.specifications}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <DataTable
      data={orders}
      columns={orderColumns}
      title="Orders"
      getRowProps={getRowProps}
      renderSubComponent={renderSubComponent}
    />
  );
}